// Configurazione del sito — modifica qui la barra promozionale e i dati del brand.
export const SITE = {
  brand: "Fatima Bio Cosmetic",
  tagline: "Botanica per il cuoio capelluto",
  promoText: "10% DI SCONTO SUL TUO PRIMO ORDINE — APPLICATO AUTOMATICAMENTE AL PAGAMENTO",
  promoCode: "PRIM10",
  instagram: "https://www.instagram.com/fatima_bio_cosmetic_it/",
  website: "fatimabiocosmetic.it",
  email: "fatimabiocosmetic98@gmail.com",
};

export const HERO_IMAGE =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_scalp-ritual-silk/artifacts/aq99q9me_IMG_0297.jpeg";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatPrice = (value) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(value);
